/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespTopModule_item = {
    readonly title: string | null;
    readonly photos: ReadonlyArray<{
        readonly smallPath: string | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactSellerButton_item">;
    readonly " $refType": "PdpRespTopModule_item";
};
export type PdpRespTopModule_item$data = PdpRespTopModule_item;
export type PdpRespTopModule_item$key = {
    readonly " $data"?: PdpRespTopModule_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespTopModule_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespTopModule_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "smallPath",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSellerButton_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '541fea722e12df6c0160b2ee36ed266f';
export default node;
